import IndexedDbCache from '@/services/IndexedDbCache/IndexedDbCache'
import type { IReactiveCache } from '@/services/IndexedDbCache/IIndexedDbCache'
import type { Chat, ChatList } from '@/store/chats/IChats'

const DB_NAME = 'chats-cache'
const STORE_NAME = 'chats'
const DB_VERSION = 1

export interface IChatsCache extends IReactiveCache<Chat> {
  getAll(): Readonly<ChatList>
  putChats(chats: ChatList): void
}

// Volatile fields that must not be persisted: they either hold non-serializable
// values or become stale immediately after a reconnect.
const disabledFields: (keyof Chat)[] = ['lastActive', 'files', 'autoDeleteMessages', 'notifyMuted']

const stripVolatileFields = (chat: Chat): Chat => {
  const result: Chat = { ...chat }
  disabledFields.forEach(name => {
    delete result[name]
  })
  return result
}

class ChatsCache extends IndexedDbCache<Chat> implements IChatsCache {
  constructor() {
    super({ dbName: DB_NAME, storeName: STORE_NAME, keyPath: '$jid', version: DB_VERSION })
  }

  getAll(): Readonly<ChatList> {
    return super.getAll()
  }

  putChats(chats: ChatList) {
    const values = Object.values(chats)
      .filter((chat): chat is Chat => Boolean(chat))
      .map(stripVolatileFields)
    this.putMany(values)
  }
}

export default ChatsCache
